module.exports = __webpack_public_path__ + "img/adv-equipment.23dae747.png";